import {beforeCheckout, checkStocks} from "@plugins-fr/payment";
import 'jquery-confirm';
import Lang from "@vendors-fr/messages";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {recordUserEventTrack} from "@commons/userTracks/userTrack";
import {checkoutPageSubmit} from "@commons/userTracks/eventActionName";

$(document).ready(function () {
    if (hasApplePayPayment) {
        var paynowApplePay = {

            'createRequest': function () {
                return {
                    countryCode: 'TW',
                    currencyCode: 'TWD',
                    supportedNetworks: ['visa', 'masterCard', 'jcb'],
                    merchantCapabilities: ['supports3DS'],
                    total: {label: shops_name, amount: cart_total}
                };
            },
            'errorResponse': function () {
                this.alert(Lang.get('frontend.orderfail.title'), cart_url);
            },
            'validateMerchant': function (event, response) {
                var _self = this;
                $.ajax({
                    url: paynow_applepay_verify_url,
                    method: "POST",
                    data: {
                        ValidationURL: event.validationURL
                    },
                    error: function (err) {
                        _self.errorResponse()
                    }
                }).then(response);
            },
            'checkout': function (response) {
                var _self = this;
                $.ajax({
                    url: payment_url,
                    method: "POST",
                    data: $("#order_form").serialize(),
                    error: function (err) {
                        _self.errorResponse()
                    }
                }).then(response);
            },
            'authorize': function (event, response) {
                var _self = this;
                $.ajax({
                    url: paynow_applepay_authorize_url,
                    method: "POST",
                    data: {
                        /* 依照 */
                        paymentData: JSON.stringify(event.payment.token.paymentData)
                    },
                    error: function (err) {
                        _self.errorResponse()
                    }
                }).then(response);
            },
            'alert': function (message, url) {
                $.alert({
                    template: JconfirmTemplateHelper.getTemplate({
                        'templateType': '01',
                        'theme': 'el_confirm'
                    }),
                    backgroundDismiss: false,
                    title: '',
                    icon: 'icon-new_exclaim_circle',
                    offsetTop: 0,
                    offsetBottom: 0,
                    buttons: {
                        confirmButton: {
                            keys: ['enter'],
                            text: Lang.get('frontend.other.btn.success'),
                            btnClass: 'btn_confirm btn_sm',
                            action: function () {
                                location.href = url;
                            }
                        }
                    },
                    onOpenBefore: function () {
                        this.setContent('<span class="content_confirm_inner">' + message + '</span>');
                    }
                });
            },
            'close': function () {
                $('#applepay').prop('disabled', false);
            }
        };


        $('#applepay').click(function () {
            // 結帳前欄位檢查
            if (!beforeCheckout($(this))) {
                return false;
            }

            var request = paynowApplePay.createRequest();
            var applepay_session = new ApplePaySession(2, request);

            // 驗證商店
            applepay_session.onvalidatemerchant = function (event) {
                // 驗證商店回傳
                var response = function (result) {
                    if (result['status']) {
                        applepay_session.completeMerchantValidation(JSON.parse(result['TransactionSession']));
                    } else {
                        applepay_session.abort();
                        paynowApplePay.close();
                    }
                };
                paynowApplePay.validateMerchant(event, response);

            };

            // 付款授權：先成立訂單再執行信用卡授權
            applepay_session.onpaymentauthorized = function (event) {
                var url;
                // 信用卡授權回傳
                var authorizeResponse = function (result) {
                    if (result) {
                        applepay_session.completePayment(ApplePaySession.STATUS_SUCCESS);
                        location.href = url;
                    } else {
                        applepay_session.completePayment(ApplePaySession.STATUS_FAILURE);
                        location.href = fail_url;
                    }
                };

                // 成立訂單回傳
                var checkoutResponse = function (result) {

                    recordUserEventTrack(checkoutPageSubmit, payment_url);

                    if (result['status']) {
                        url = result['url'];
                        // 信用卡授權
                        paynowApplePay.authorize(event, authorizeResponse);
                    } else if (!result['status'] && result['type'] === 'Success') {
                        location.href = result['url'];
                    } else {
                        paynowApplePay.alert(result['message'], result['url'])
                        paynowApplePay.close();
                    }
                };

                // 成立訂單
                paynowApplePay.checkout(checkoutResponse);
            };

            // 取消
            applepay_session.oncancle = paynowApplePay.close();

            // 庫存檢查
            checkStocks(false, $(this), function () {
                // 開始交易
                applepay_session.begin();
            });
        });
    }
});

